import React, { useEffect, useRef, useState } from "react";
import { moneyFormat } from "../../util/format";

const Countdown = ({ seconds = 1800, styleObj }) => {
  const [timeLeft, setTimeLeft] = useState(seconds);

  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => setTimeLeft((t) => t - 1), 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  const pad = (n) => n.toString().padStart(2, "0");
  const h = Math.floor(timeLeft / 3600);
  const m = Math.floor((timeLeft % 3600) / 60);
  const s = timeLeft % 60;
  return (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        gap: 4,
        fontWeight: "bold",
        fontSize: styleObj.timerFont,
      }}
    >
      <span
        style={{
          background: "#000",
          color: "#fff",
          padding: `0 ${styleObj.block / 8}px`,
          borderRadius: 5,
          minWidth: styleObj.block,
          textAlign: "center",
          display: "inline-block",
        }}
      >
        {pad(h)}
      </span>
      <span>:</span>
      <span
        style={{
          background: "#000",
          color: "#fff",
          padding: `0 ${styleObj.block / 8}px`,
          borderRadius: 5,
          minWidth: styleObj.block,
          textAlign: "center",
          display: "inline-block",
        }}
      >
        {pad(m)}
      </span>
      <span>:</span>
      <span
        style={{
          background: "#000",
          color: "#fff",
          padding: `0 ${styleObj.block / 8}px`,
          borderRadius: 5,
          minWidth: styleObj.block,
          textAlign: "center",
          display: "inline-block",
        }}
      >
        {pad(s)}
      </span>
    </span>
  );
};

function useResponsiveStyle() {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200,
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Responsive từng ngưỡng (có thể chỉnh theo ý bạn)
  let base = {
    rootFont: 16,
    priceFont: 22,
    titleFont: 17,
    timerFont: 15,
    icon: 16,
    block: 32,
    redPad: "16px 18px 16px 24px",
    yellowPad: "16px 12px 16px 16px",
    originalFont: 15,
    discountFont: 15,
    discountPad: "1.5px 9px",
  };
  if (windowWidth <= 900) {
    base = {
      ...base,
      rootFont: 14,
      priceFont: 20,
      titleFont: 15,
      timerFont: 14,
      icon: 14,
      block: 28,
      redPad: "12px 10px 12px 12px",
      yellowPad: "12px 15px 12px 14px",
      originalFont: 13,
      discountFont: 13,
      discountPad: "1px 7px",
    };
  }
  if (windowWidth <= 600) {
    base = {
      ...base,
      rootFont: 13,
      priceFont: 18,
      titleFont: 13,
      timerFont: 13,
      icon: 13,
      block: 25,
      redPad: "10px 6px 10px 10px",
      yellowPad: "10px 10px 10px 10px",
      originalFont: 12,
      discountFont: 12,
      discountPad: "0.8px 5px",
    };
  }
  if (windowWidth <= 400) {
    base = {
      ...base,
      rootFont: 12,
      priceFont: 16,
      titleFont: 14,
      timerFont: 14,
      icon: 12,
      block: 19,
      redPad: "8px 6px 8px 14px",
      yellowPad: "8px 6px 8px 14px",
      originalFont: 14,
      discountFont: 16,
      discountPad: "0.5px 3.5px",
    };
  }
  return base;
}

const FlashDealPriceBar = ({
  price,
  originalPrice,
  countdownSeconds = 1800,
}) => {
  const styleObj = useResponsiveStyle();
  const timerRowRef = useRef(null);
  const [timerDirection, setTimerDirection] = useState("row");

  // Đo width của dòng timer cha, nếu nhỏ hơn 200px thì chuyển dọc, đủ thì ngang
  useEffect(() => {
    function handleCheckWidth() {
      if (timerRowRef.current) {
        const width = timerRowRef.current.offsetWidth;
        setTimerDirection(width < 200 ? "column" : "row");
      }
    }
    handleCheckWidth();
    window.addEventListener("resize", handleCheckWidth);
    return () => window.removeEventListener("resize", handleCheckWidth);
  }, []);

  const discount =
    price && originalPrice
      ? Math.round(100 - (price * 100) / originalPrice)
      : null;

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "stretch",
        minHeight: 64,
        borderRadius: 12,
        overflow: "hidden",
        boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
        fontSize: styleObj.rootFont,
      }}
    >
      {/* Phần màu đỏ */}
      <div
        style={{
          width: "50%",
          background: "#ff1e1e",
          color: "#fff",
          padding: styleObj.redPad,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 4,
          }}
        >
          <i
            className="fa fa-ticket mr-2"
            style={{
              fontSize: styleObj.icon,
              marginRight: 8,
              flexShrink: 0,
            }}
          />
          <span
            style={{
              fontWeight: 700,
              fontSize: styleObj.priceFont,
              lineHeight: "1",
            }}
          >
            {moneyFormat(price)}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <span
            style={{
              textDecoration: "line-through",
              opacity: 0.8,
              fontSize: styleObj.originalFont,
              marginRight: 8,
            }}
          >
            {moneyFormat(originalPrice)}
          </span>
          {discount ? (
            <span
              style={{
                background: "rgba(0,0,0,0.12)",
                borderRadius: 7,
                fontWeight: 700,
                fontSize: styleObj.discountFont,
                padding: styleObj.discountPad,
                color: "#fff",
              }}
            >
              {discount}%
            </span>
          ) : null}
        </div>
      </div>
      {/* Phần màu vàng */}
      <div
        style={{
          width: "50%",
          background: "#fdde52",
          color: "#111",
          padding: styleObj.yellowPad,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
            fontSize: styleObj.titleFont,
            marginBottom: 4,
          }}
        >
          <i
            className="fa fa-bolt mr-2"
            style={{
              color: "#111",
              fontSize: styleObj.icon,
              marginRight: 8,
              flexShrink: 0,
            }}
          />
          Ưu đãi giờ vàng
        </div>
        <div
          ref={timerRowRef}
          style={{
            display: "flex",
            flexDirection: timerDirection,
            alignItems: timerDirection === "row" ? "center" : "flex-start",
            gap: 7,
            fontSize: styleObj.timerFont,
            marginTop: 2,
            width: "100%",
          }}
        >
          <span>Kết thúc sau</span>
          <Countdown seconds={countdownSeconds} styleObj={styleObj} />
        </div>
      </div>
    </div>
  );
};

export default FlashDealPriceBar;
